module.exports = __webpack_public_path__ + "img/shijian.ceb2e536.png";